import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";

export const EditorForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
`;

export const EditorFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
`;

export const EditorError = styled.span`
  display: block;
  margin-top: ${SPACING.xs}px;
  font-size: var(--text-sm);
  color: var(--color-error);
`;

export const EditorWarning = styled.span`
  font-size: var(--text-sm);
  color: var(--color-warning);
`;

export const EditorRetryRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
  margin-top: ${SPACING.xs}px;
`;

export const EditorActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
`;

export const FindAction = styled.div`
  display: flex;
`;

export const OptionSymbol = styled.span`
  font-weight: 600;
`;

export const OptionMeta = styled.span`
  margin-left: ${SPACING.xs}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const FixSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
  padding-top: ${SPACING.md}px;
  border-top: 1px solid var(--color-border);
`;

export const FixSectionTitle = styled.h3`
  margin: 0;
  font-size: var(--text-base);
`;
